<template>
  <div>
    <div v-if="info">
      <div class="image-box">
        <video
          class="banner-img"
          :src="info.cover"
          controls
          playsinline
          webkit-playsinline
          x5-playsinline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="false"
          controlslist="nofullscreen"
        ></video>
        <!-- <img :src="info.cover" alt="" class="banner-img" @click="show = true" /> -->
      </div>
      <div class="main-centent">
        <img
          src="../assets/back-icon.png"
          alt=""
          class="back-icon"
          @click="goBack"
        />
        <p class="title">{{ info.name }}</p>
        <div>来源：{{ info.company }}</div>
        <div>作者：{{ info.author }}</div>
        <div class="intro-title">作品简介：</div>
        <div v-html="info.contents"></div>
      </div>
    </div>
    <Popup v-model="show">
      <div class="img-content" v-if="info">
        <img :src="info.cover" alt="" />
      </div>
    </Popup>
  </div>
</template>

<script>
import { getDetail } from '../api/index';
import { Popup } from 'vant';

export default {
  components: {
    Popup,
  },
  data() {
    return {
      info: null,
      show: false,
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {},

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      getDetail({
        id: this.$route.query.id,
      }).then((res) => {
        if (res.code === 200) {
          this.info = res.data;
        } else {
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.image-box {
  width: 375px;
  height: 375px;
  background: #e8e8e8;
  display: flex;
  justify-content: center;
  align-items: center;
  video {
    max-width: 100%;
    max-height: 100%;
  }
}
.main-centent {
  padding: 15px 20px;
  border-radius: 15px 15px 0px 0px;
  width: 375px;
  box-sizing: border-box;
  position: relative;
  top: -15px;
  z-index: 10;
  background: #fff;
  .title {
    font-size: 16px;
    color: #000000;
    margin-bottom: 13px;
  }
  > div {
    font-size: 16px;
    color: #666666;
    margin-bottom: 10px;
  }
  .intro-title {
    margin-bottom: 6px;
  }
}
.back-icon {
  width: 91px;
  height: 20px;
  margin-bottom: 13px;
}
.img-content {
  img {
    width: 375px;
    max-height: 100vh;
    object-fit: cover;
  }
}
</style>